var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-icon',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.active),expression:"active",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"loading"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }